var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.linkManage ? 'Cách tính xem chi tiết' : 'Hướng dẫn cách tính thuế')+" "),_c('a',{staticStyle:{"color":"#409EFF"},attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v("TẠI ĐÂY")])])
}
var staticRenderFns = []

export { render, staticRenderFns }